import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Container, Row, Col } from "react-bootstrap";
import Modal from "react-modal";
import MealsStructure from "../../diet/meal/MealsStructure";
import CmnFilters from "../common/CmnFilters";
import RawLeadListings from "./RawLeadListings";
import RawLeadStatCards from "./RawLeadStatCards";
import { fetchRawLeadStatsData } from "../../../redux/reducers/apiSlice";
import { extractConvertedTo, getCardValue } from "./RawLeadCommon";
import ModalHeader from "../../ModalHeader";
import SelectExportables from "../../common-components/SelectExportables";
import { fetchExportApiData } from "../../../redux/reducers/commonApiSlice";
import { exportRawLead } from "../../../data/ApiEndpoints";
import { toast } from "react-toastify";
import { rawLeadExportableData } from "../../pt-trials/common/SharedDatas";

const RawLeads = ({ userInfoData }) => {
  const dispatch = useDispatch();
  const tableRef = useRef(null);
  const isAdmin = userInfoData?.account_type === "admin";
  const isGym = userInfoData?.account_type === "gym";
  const isMarketing = userInfoData?.account_type === "marketing";
  const isClusterManager = userInfoData?.account_type === "cluster_manager";

  const { exportData, exportLoading } = useSelector((state) => state.common);

  const [isPage, setIsPage] = useState(0);
  const [pageLimit, setPageLimit] = useState(10);
  const iniAllFilter = {
    clickedCard: "",
    selectedGym:
      !isAdmin && !isMarketing && !isClusterManager
        ? {
            label: isGym ? userInfoData?.name : userInfoData?.gym_name || "",
            value:
              userInfoData?.gym_id ||
              userInfoData?.user_id ||
              userInfoData?.uid ||
              "",
          }
        : "",
    selAddedby: "",
    selAssginee:
      !isAdmin && !isMarketing && !isClusterManager
        ? {
            label: userInfoData?.name || "",
            value: userInfoData?.uid || userInfoData?.user_id || "",
          }
        : "",
    selAutomationKeyword: "",
    selCity: "",
    selFilterType: "",
    selConvertedIn: [],
    selLeadSource: "",
    selUTMSource: "",
    selUTMMedium: "",
    selUTMContent: "",
    selUTMTerm: "",
    selUTMCampaign: "",

    selAssignedLeadDay: "",
    selAssignedLeadHour: "",
    selAssignedLeadMinute: "",
    selAssignLeadFollowupDay: "",
    selAssignLeadFollowupHour: "",
    selAssignLeadFolloupMinute: "",

    leadAddDateFrom: "",
    leadAddDateTo: "",
    leadAssignDateFrom: "",
    leadAssignDateTo: "",
    searchString: "",
  };
  const [allFilters, setAllFilters] = useState(iniAllFilter);
  const iniFilters = {
    page: isPage + 1,
    limit: pageLimit || 10,
    filter_type: allFilters.selFilterType?.value || "all",
    gym_id: allFilters.selectedGym?.value || "",
    assigned_to: allFilters.selAssginee?.value || "",
    added_by: allFilters.selAddedby?.value || "",
    keyword_name: allFilters.selAutomationKeyword?.label || "",
    source_name: allFilters.selLeadSource?.value || "",
    city: allFilters.selCity?.label || "",
    conversion_days: "",
    utm_source: allFilters.selUTMSource?.value || "",
    utm_medium: allFilters.selUTMMedium?.value || "",
    utm_content: allFilters.selUTMContent?.value || "",
    utm_term: allFilters.selUTMTerm?.value || "",
    utm_campaign: allFilters.selUTMCampaign?.value || "",

    rawlead_to_assign_day: allFilters.selAssignedLeadDay?.value || "",
    rawlead_to_assign_hour: allFilters.selAssignedLeadHour?.value || "",
    rawlead_to_assign_min: allFilters.selAssignedLeadMinute?.value || "",
    assign_to_followup_day: allFilters.selAssignLeadFollowupDay?.value || "",
    assign_to_followup_hour: allFilters.selAssignLeadFollowupHour?.value || "",
    assign_to_followup_min: allFilters.selAssignLeadFolloupMinute?.value || "",

    date_from: allFilters.leadAddDateFrom || "",
    date_to: allFilters.leadAddDateTo || "",
    assign_date_start: allFilters.leadAssignDateFrom || "",
    assign_date_end: allFilters.leadAssignDateTo || "",
  };
  const [filters, setFilters] = useState(iniFilters);
  const [searchFilterApplied, setSearchFilterApplied] = useState(false);
  const initialClickValues = {
    isModOpen: false,
    name: "",
  };
  const [clickValues, setClickValues] = useState(initialClickValues);
  const [csvData, setCsvData] = useState();

  const onCloseModal = (name) => {
    setClickValues(initialClickValues);
    setCsvData();
  };

  const onResetFilters1 = () => {
    setAllFilters(iniAllFilter);
  };

  const onClickSearch = () => {
    setIsPage(0);

    if (allFilters.searchString) {
      setSearchFilterApplied(true);
      setFilters((prevs) => ({ ...prevs, search: allFilters.searchString }));
    }
  };

  const onClickLeadCard = (key) => {
    setAllFilters((prevs) => ({
      ...prevs,
      clickedCard: key,
      selFilterType: {
        label: key?.replace(/_/g, " "),
        value: getCardValue(key?.replace(/ /g, "_")),
      },
    }));
  };

  function getRawLeadStats() {
    const filters = { is_rawlead: 1 };

    dispatch(
      fetchRawLeadStatsData({
        filters: filters,
        token: userInfoData?.token,
      })
    );
  }

  function getExportedData(filters) {
    dispatch(
      fetchExportApiData({
        method: "GET",
        endpoint: exportRawLead,
        payload: {
          filters: filters,
        },
        token: userInfoData?.token,
      })
    );
  }

  const onClickExport = (filters) => {
    if (filters.is_export) {
      getExportedData(filters);
    } else {
      toast.error("IS Export Not Found!");
    }
  };

  useEffect(() => {
    getRawLeadStats();
  }, []);

  // useEffect(() => {
  //   setAllFilters((prevs) => ({
  //     ...prevs,
  //     selectedGym:
  //       !isAdmin && !isMarketing && !isClusterManager
  //         ? {
  //             label: isGym ? userInfoData?.name : userInfoData?.gym_name || "",
  //             value:
  //               userInfoData?.gym_id ||
  //               userInfoData?.user_id ||
  //               userInfoData?.uid ||
  //               "",
  //           }
  //         : "",
  //   }));
  // }, [userInfoData?.gym_id]);

  // useEffect(() => {
  //   setFilters((prevs) => ({
  //     ...prevs,
  //     page: isPage + 1,
  //     limit: pageLimit,
  //   }));
  // }, [isPage, pageLimit]);

  useEffect(() => {
    const { converted_days_ago } = extractConvertedTo(
      allFilters.selConvertedIn
    );

    setFilters((prevs) => ({
      ...prevs,
      page: isPage + 1,
      limit: pageLimit,

      filter_type: allFilters.selFilterType?.value || "all",
      gym_id: allFilters.selectedGym?.value || "",
      assigned_to: allFilters.selAssginee?.value || "",
      added_by: allFilters.selAddedby?.value || "",
      keyword_name: allFilters.selAutomationKeyword?.label || "",
      source_name: allFilters.selLeadSource?.value || "",
      utm_source: allFilters.selUTMSource?.value || "",
      city: allFilters.selCity?.label || "",
      conversion_days: converted_days_ago || "",
      utm_medium: allFilters.selUTMMedium?.value || "",
      utm_content: allFilters.selUTMContent?.value || "",
      utm_term: allFilters.selUTMTerm?.value || "",
      utm_campaign: allFilters.selUTMCampaign?.value || "",

      rawlead_to_assign_day: allFilters.selAssignedLeadDay?.value || "",
      rawlead_to_assign_hour: allFilters.selAssignedLeadHour?.value || "",
      rawlead_to_assign_min: allFilters.selAssignedLeadMinute?.value || "",
      assign_to_followup_day: allFilters.selAssignLeadFollowupDay?.value || "",
      assign_to_followup_hour:
        allFilters.selAssignLeadFollowupHour?.value || "",
      assign_to_followup_min:
        allFilters.selAssignLeadFolloupMinute?.value || "",

      date_from: allFilters.leadAddDateFrom || "",
      date_to: allFilters.leadAddDateTo || "",
      assign_date_start: allFilters.leadAssignDateFrom || "",
      assign_date_end: allFilters.leadAssignDateTo || "",
    }));
    // setIsPage(0);
  }, [
    isPage,
    pageLimit,
    allFilters.selFilterType,
    allFilters.selectedGym,
    allFilters.selAssginee,
    allFilters.selAddedby,
    allFilters.selAutomationKeyword,
    allFilters.selLeadSource,
    allFilters.selCity,
    allFilters.selConvertedIn,
    allFilters.selUTMSource,
    allFilters.selUTMMedium,
    allFilters.selUTMContent,
    allFilters.selUTMTerm,
    allFilters.selUTMCampaign,

    allFilters.selAssignedLeadDay,
    allFilters.selAssignedLeadHour,
    allFilters.selAssignedLeadMinute,
    allFilters.selAssignLeadFollowupDay,
    allFilters.selAssignLeadFollowupHour,
    allFilters.selAssignLeadFolloupMinute,

    allFilters.leadAddDateFrom,
    allFilters.leadAddDateTo,
    allFilters.leadAssignDateFrom,
    allFilters.leadAssignDateTo,
  ]);

  useEffect(() => {
    if (allFilters.searchString?.length === 0) {
      setSearchFilterApplied(false);
      setFilters((prevs) => ({ ...prevs, search: "" }));
      setIsPage(0);
    }
  }, [allFilters.searchString]);

  useEffect(() => {
    if (exportData) {
      setCsvData(exportData);
    }
  }, [exportData]);

  return (
    <Container className="bg-cloud-k px-50px" fluid>
      <Modal
        isOpen={clickValues.isModOpen}
        onRequestClose={onCloseModal}
        contentLabel="Modal"
        ariaHideApp={false}
      >
        <div className={`createNewCTOModalContainer`}>
          {clickValues.name === "exportModal" ? (
            <>
              <ModalHeader
                title={"Select Fields To Export"}
                onClick={onCloseModal}
              />
              <div>
                <SelectExportables
                  name={"raw-lead"}
                  exportableData={rawLeadExportableData}
                  filters={filters}
                  callFunction={onClickExport}
                  isLoadingCSV={exportLoading}
                  csvData={csvData}
                  setCsvData={setCsvData}
                />
              </div>
            </>
          ) : null}
        </div>
      </Modal>

      <Row>
        <Col>
          <MealsStructure text={"Raw Lead Management"} />
        </Col>
      </Row>
      <Row>
        <Col>
          {/* <CmnFilters
            from={"raw-lead"}
            userInfoData={userInfoData}
            onClickReset={onResetFilters}
            filters={allFilters}
            setFilters={setAllFilters}
            onClickSearch={onClickSearch}
            searchFilterApplied={searchFilterApplied}
            isAdminView={true}
            isTop={true}
          /> */}
        </Col>
      </Row>
      <Row>
        <Col>
          <RawLeadStatCards
            userInfoData={userInfoData}
            filters={filters}
            onClickLeadCard={onClickLeadCard}
            prevClickedCard={allFilters.clickedCard}
            tableRef={tableRef}
            allFilters={allFilters}
            setAllFilters={setAllFilters}
          />
        </Col>
      </Row>
      <Row>
        <Col>
          <CmnFilters
            from={"raw-lead"}
            userInfoData={userInfoData}
            onClickReset={onResetFilters1}
            filters={allFilters}
            setFilters={setAllFilters}
            onClickSearch={onClickSearch}
            searchFilterApplied={searchFilterApplied}
            isAdminView={true}
            isTop={false}
            onClickExportBtn={() =>
              setClickValues({
                isModOpen: true,
                name: "exportModal",
              })
            }
          />
        </Col>
      </Row>
      <br />
      <Row>
        <Col>
          <RawLeadListings
            userInfoData={userInfoData}
            isPage={isPage}
            setIsPage={setIsPage}
            pageLimit={pageLimit}
            setPageLimit={setPageLimit}
            filters={filters}
            tableRef={tableRef}
            callFunction={getRawLeadStats}
          />
        </Col>
      </Row>
    </Container>
  );
};

export default RawLeads;
